/**
 * THIS FILE IS AUTOMATICALLY GENERATED BY genColors.js.
 *
 * DO NOT MANUALLY MODIFY THIS FILE.
 */

enum ColorVariableName {
  AliceBlue = "--color-aliceBlue",
  AntiFlashWhite = "--color-antiFlashWhite",
  ArtistPillShadow = "--color-artistPillShadow",
  BackgroundOverlay = "--color-backgroundOverlay",
  BackgroundOverlayDark = "--color-backgroundOverlayDark",
  BlueGradient = "--color-blueGradient",
  BrightGray = "--color-brightGray",
  BrightPurple = "--color-brightPurple",
  CadmiumGreen = "--color-cadmiumGreen",
  CardBackground = "--color-cardBackground",
  ClickableAreaBackground = "--color-clickableAreaBackground",
  Cultured = "--color-cultured",
  DarkCerulean = "--color-darkCerulean",
  DarkGunmetal = "--color-darkGunmetal",
  DarkPurple = "--color-darkPurple",
  Dimmer = "--color-dimmer",
  Error = "--color-error",
  FloatingElement = "--color-floatingElement",
  Footer = "--color-footer",
  Ghost = "--color-ghost",
  Green = "--color-green",
  GreenGradient = "--color-greenGradient",
  GreenishGray = "--color-greenishGray",
  LightBlue = "--color-lightBlue",
  LightPink = "--color-lightPink",
  LightPurple = "--color-lightPurple",
  LightPurpleGradient = "--color-lightPurpleGradient",
  LightPurpleHover = "--color-lightPurpleHover",
  LightPurpleVerticalGradient = "--color-lightPurpleVerticalGradient",
  LinkWater = "--color-linkWater",
  MaximumRed = "--color-maximumRed",
  MediumBlue = "--color-mediumBlue",
  MenuPopup = "--color-menuPopup",
  MidnightBlue = "--color-midnightBlue",
  Navy = "--color-navy",
  NavyHover = "--color-navyHover",
  OverlayButton = "--color-overlayButton",
  PhantomPurple = "--color-phantomPurple",
  Pink = "--color-pink",
  PinkVerticalGradient = "--color-pinkVerticalGradient",
  PopheadzDarkGray = "--color-popheadzDarkGray",
  PopheadzLightGray = "--color-popheadzLightGray",
  Primary = "--color-primary",
  ProgressBar = "--color-progressBar",
  Purple = "--color-purple",
  PurpleGradient = "--color-purpleGradient",
  PurpleGradientForText = "--color-purpleGradientForText",
  PurpleGradientHover = "--color-purpleGradientHover",
  Red = "--color-red",
  RedGradient = "--color-redGradient",
  RedHover = "--color-redHover",
  Scheme11 = "--color-scheme11",
  Scheme12 = "--color-scheme12",
  Scheme21 = "--color-scheme21",
  Scheme22 = "--color-scheme22",
  Scheme31 = "--color-scheme31",
  Scheme32 = "--color-scheme32",
  Scheme41 = "--color-scheme41",
  Scheme42 = "--color-scheme42",
  Scheme51 = "--color-scheme51",
  Scheme52 = "--color-scheme52",
  Scheme61 = "--color-scheme61",
  Scheme62 = "--color-scheme62",
  Seashell = "--color-seashell",
  Secondary = "--color-secondary",
  Shader = "--color-shader",
  Sinopia = "--color-sinopia",
  SkeletonBase = "--color-skeletonBase",
  SkeletonHighlight = "--color-skeletonHighlight",
  SpotlightOverlay = "--color-spotlightOverlay",
  Tertiary = "--color-tertiary",
  Transparent = "--color-transparent",
  WebsiteBackground = "--color-websiteBackground",
  White = "--color-white",
  Yellow = "--color-yellow",
}

export default ColorVariableName;
